import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header/Header";
import ScrollManager from "./ScrollManager";
import Footer from "../components/Footer/Footer";
import '../layouts/MainLayouts.css';
import { Container } from 'react-bootstrap'; 

const MainLayouts = () => {

    const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === "/";
  return (
    <div className="layout">

      <ScrollManager />

      <Header />
        {!isHomePage && (
        <div className="back-button-wrapper">
         <Container >
          <button
            type="button"
            className="back-button"
            onClick={() => navigate(-1)}
          >
            ← Назад
          </button>
            </Container>
        </div>
      )}

      <main className="layout-main">
        <Outlet />
      </main>

      <Footer />

    </div>
  );
};

export default MainLayouts;